import { Button, Col, Form, Input, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import AddressAutocomplete from "../../Common/AddressAutocomplete";
import { getStates, getCounties, fetchLoanLimits } from "./Address";
import * as com from "Common.js";
import { set } from "lodash";
const AddressForm = ({
  form,
  addressLabel = "Address",
  addressName = "address",
  stateName = "state",
  cityName = "city",
  countyName = "county",
  zipName = "zip",
  unitName = "unit",
  listName = [], // 用于Form.List时，传入的name只是[fieldName,name],Form.List上name与listName一致
}) => {
  const [loanLimits, setloanLimits] = useState([]);
  const loanState = Form.useWatch(Array.isArray(stateName)?[...listName,...stateName]:stateName, form);
  const address = Form.useWatch(Array.isArray(addressName)?[...listName,...addressName]:addressName, form);
  
  useEffect(() => {
    fetchLoanLimits(setloanLimits);
  }, []);

  const getPath = (name) =>{
    const isArr = Array.isArray(listName);
      let path = listName
        ? [...(isArr ? listName : [listName]), ...name]
        : name;
      const newPath = path.map((p) =>
        typeof p === "number" ? p.toString() : p
      );
      return newPath;
  }

  const onStreetAddressCompletion = (address) => {
    let num = com.getSubaddress(address, "street_number", "long_name");
    let city = com.getSubaddress(address, "locality", "long_name");
    let state = com.getSubaddress(
      address,
      "administrative_area_level_1",
      "short_name"
    );
    let zip = com.getSubaddress(address, "postal_code", "long_name");
    let county = com.getSubaddress(
      address,
      "administrative_area_level_2",
      "long_name"
    );

    let longstate = com.getSubaddress(
      address,
      "administrative_area_level_1",
      "long_name"
    );
    let short = com.getSubaddress(address, "route", "short_name");
    let stradd = num + " " + short;
    if (Array.isArray(addressName)) {
      
      const newValue = form.getFieldsValue() || {};
      set(newValue, getPath(addressName), stradd);
      set(newValue, getPath(stateName), state);
      set(newValue, getPath(countyName), county);
      set(newValue, getPath(cityName), city);
      set(newValue, getPath(zipName), zip);
      form.setFieldsValue(newValue);
    } else {
      form.setFieldsValue({
        [addressName]: stradd,
        [stateName]: state,
        [countyName]: county,
        [cityName]: city,
        [zipName]: zip,
      });
    }
  };
  const changeAddress = ({ target: { value } }) => {
    if (Array.isArray(addressName)) {
      const newValue = form.getFieldsValue() || {};
      set(newValue, getPath(addressName), value);
      form.setFieldsValue(newValue);
    } else {
      form.setFieldsValue({
        [addressName]: value,
      });
    }
  };
  return (
    <>
      <Col span={24}>
        <Form.Item name={addressName}>
          <AddressAutocomplete
            defaultValue={address}
            name="address"
            label={addressLabel}
            autoComplete="off"
            onCompletion={onStreetAddressCompletion}
            placeholder={addressLabel}
            onChange={changeAddress}
            pattern="^[0-9]+\s[\p{L}\p{N} !:,&()'?#+\/@-]+$"
            badfeedback="Please provide address of the property"
            addressStyles={{ marginBottom: 0 }}
          />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item name={unitName}>
          <Input
            size="large"
            placeholder="Apt, suite, building, etc. (Optional)"
          />
        </Form.Item>
      </Col>
      <Col md={6} xs={24}>
        <Form.Item name={stateName}>
          <Select
            style={{ width: "100%", height: 44 }}
            placeholder="Select state"
          >
            {getStates(loanLimits).map((x, index) => (
              <Select.Option value={x.value} key={index}>
                {x.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col md={6} xs={24}>
        <Form.Item name={countyName}>
          <Select style={{ width: "100%", height: 44 }}>
            {getCounties(loanLimits, loanState).map((x, index) => (
              <Select.Option value={x.value} key={index}>
                {x.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col md={6} xs={24}>
        <Form.Item name={cityName}>
          <Input size="large" placeholder="City" />
        </Form.Item>
      </Col>
      <Col md={6} xs={24}>
        <Form.Item name={zipName}>
          <Input size="large" placeholder="Zip Code" />
        </Form.Item>
      </Col>
    </>
  );
};
export default AddressForm;
